/**
 * EAA-1820: pulled out of `ProfilePage.tsx` unchanged (was a module-scope
 * function there) so `ProfileSessionsTab.tsx` can reuse it for both the
 * "Bắt đầu" and "Hoạt động gần nhất" columns (frame 79's table has both;
 * the pre-tab layout only rendered the latter).
 *
 * `session.start` / `session.last_access` — Keycloak `UserSessionRepresentation`
 * epoch-ms timestamps, per `keycloak_admin.list_sessions` (portal-api). Never
 * fabricate a time when it's missing.
 */
export function formatSessionTime(ms: number | null | undefined, unknownLabel: string): string {
    if (!ms) return unknownLabel;
    try {
        return new Intl.DateTimeFormat('vi-VN', { dateStyle: 'short', timeStyle: 'short' }).format(
            new Date(ms)
        );
    } catch {
        return unknownLabel;
    }
}
